var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6H14V8H2V6ZM2 9.99999H14V12H2V9.99999ZM2 16H10V14H2V16ZM21.8538 12.021C22.0487 11.826 22.0487 11.5111 21.8538 11.3161L20.6839 10.1462C20.4889 9.95126 20.174 9.95126 19.979 10.1462L19.0641 11.0611L20.9389 12.9359L21.8538 12.021ZM13 17.1253V19.0001H14.8747L20.404 13.4708L18.5293 11.596L13 17.1253Z",
    fill: "#98BECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListEdit);
export default __webpack_public_path__ + "static/media/list_edit.ecc60950827fc6859f13cff32f49c3e5.svg";
export { ForwardRef as ReactComponent };